import { createContext } from 'react';

import { GoogleTagManagerContextType } from './google-tag-manager.type';

export const GoogleTagManagerContext = createContext<GoogleTagManagerContextType | null>(null);
